import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'magnific-popup/dist/magnific-popup.css';
import 'intl-tel-input/build/css/intlTelInput.css';
import 'jquery-form-styler/dist/jquery.formstyler.css';
import "style/layout/base";
import "block/common";

import Registration from "base/Registration";

(function () {
	"use strict";
	document.addEventListener("DOMContentLoaded", function () {
		Fancybox.bind("[data-fancybox]");
		Registration.blocksInit();
	});
})();
